import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { NAV } from "./Nav";
import { CONTACT_EMAIL } from "@/data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#262b38] bg-[#0c0e12]">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-10 py-20 grid gap-14 md:grid-cols-12">
      <div className="md:col-span-5 space-y-6">
        <Logo />
        <p className="text-[#a7aebb] max-w-sm leading-relaxed">
          Architectural and build services for the North West. Designed in Preston, built properly across the region.
        </p>
      </div>
      <div className="md:col-span-3">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#a7aebb] mb-5">Index</p>
        <ul className="space-y-3">
          {NAV.map((n) => (
            <li key={n.to}>
              <Link to={n.to} data-testid={`footer-link-${n.label.toLowerCase()}`} className="hover:text-[#d96b27] transition-colors">
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-4 space-y-4">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#a7aebb] mb-5">Studio</p>
        <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-[#d96b27] transition-colors break-all">
          <Mail className="w-4 h-4 shrink-0 text-[#d96b27]" /> {CONTACT_EMAIL}
        </a>
        <p className="flex items-center gap-3">
          <MapPin className="w-4 h-4 shrink-0 text-[#d96b27]" /> Preston, Lancashire — serving the North West
        </p>
      </div>
    </div>
    <div className="border-t border-[#262b38]">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 font-mono text-xs text-[#a7aebb]">
        <span>© {new Date().getFullYear()} Interior Box. All rights reserved.</span>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#f4f5f7]">Studio login</Link>
      </div>
    </div>
  </footer>
);
